import { render, staticRenderFns } from "./TenzoSettings.vue?vue&type=template&id=20dc92e4"
import script from "./TenzoSettings.vue?vue&type=script&lang=js"
export * from "./TenzoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports